/* tslint:disable */
/* eslint-disable */

/**
 * Date format of the emails (MM/DD/YYYY, DD/MM/YYYY, YYYY-MM-DD or MMM DD, YYYY).
 */
export enum EmailDateFormat {
  MmDdYyyy = 'MM_DD_YYYY',
  DdMmYyyy = 'DD_MM_YYYY',
  YyyyMmDd = 'YYYY_MM_DD',
  MmmDdYyyy = 'MMM_DD_YYYY'
}
